import styled from 'styled-components';
import { ReactComponent as Chevron } from '../../assets/svg/chevron-right.svg';

export const ChevronRight = styled(Chevron)<{ disabled?: boolean }>`
  stroke: ${({ theme, disabled }) =>
    disabled ? theme.palette.switch.text.inactive : theme.palette.brand.color};
`;

export const ChevronLeft = styled(ChevronRight)`
  transform: rotate(180deg);
`;

const NavButton = styled.button`
  background-color: unset;
  border: none;
  border-radius: 0.5rem;
  cursor: ${({ disabled }) => (disabled ? 'unset' : 'pointer')};
  display: flex;
  padding: 0.1rem;
  position: absolute;
  top: 0.5rem;
  z-index: 99;

  :hover {
    background-color: ${({ theme, disabled }) =>
      disabled ? 'unset' : theme.palette.commons.tonal.base};
  }
`;

export const PreviousMonthButton = styled(NavButton)`
  left: 0.5rem;
`;

export const NextMonthButton = styled(NavButton)`
  right: 0.5rem;
`;
